import { render } from "./Campaigns.vue?vue&type=template&id=58d9709a"
import script from "./Campaigns.vue?vue&type=script&lang=ts"
export * from "./Campaigns.vue?vue&type=script&lang=ts"
script.render = render

export default script